export * from './dance-studio-images-dialog.component';
export * from './dance-studio-images-dialog.module';
